import React from 'react';
import Modal from "./index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function ConfirmModal({
  visible,
  onOK,
  onCancel,
  children,
  disableButtons = false,
  okText = 'OK',
  cancelText = 'Cancel',
  ...other
}) {
  return /*#__PURE__*/_jsxs(Modal, {
    visible: visible,
    ...other,
    children: [/*#__PURE__*/_jsx("div", {
      className: "modal-header",
      children: /*#__PURE__*/_jsx("h5", {
        className: "modal-title",
        children: "Confirmation"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "modal-body",
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: "modal-footer",
      children: [/*#__PURE__*/_jsx("button", {
        type: "button",
        className: "btn btn-secondary",
        onClick: onCancel,
        disabled: disableButtons,
        children: cancelText
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: onOK,
        disabled: disableButtons,
        children: okText
      })]
    })]
  });
}

export default ConfirmModal;
//# sourceMappingURL=ConfirmModal.js.map